import { Component, ojs, app, state, v, payload } from "modular-openscriptjs";
import {
    pageInfo,
    eParse,
    inform,
    appIsLocal,
    consoleErrorOnLocal,
    cleanDispose,
    scrollToTop,
} from "../../../helpers";
import { api, gc } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";
import { dom, tool } from "../../../fotastart";
import { $e } from "../../../ojs.events";
import CheckYesno from "../../Blocks/CheckYesno";

const h = app("h");
const broker = app("broker");
const router = app("router");

ojs(SolidIcon, CheckYesno);

export default class ManageBranches extends Component {
    businessId = null;
    branches = state([]);
    loading = state(true);
    pickedLocation = state("");
    holder = null;

    formData = {
        name: "",
        location: "",
        latitude: "",
        longitude: "",
        readable_address: "",
        contact_phone: gc?.user?.value?.phone,
        contact_email: gc?.user?.value?.email,
    };

    $$map = {
        has: {
            location: (ed) => {
                let { meta, message } = eParse(ed);

                if (meta.from !== "BRANCH_ADDRESS_FORM") return;

                this.formData.latitude = message.latitude;
                this.formData.longitude = message.longitude;
                this.formData.location = message.address;
                this.pickedLocation.value = message.address;

                inform("Location selected!", "success");
            },
        },
    };

    render() {
        this.businessId = router.params.companyId;
        scrollToTop();

        if (this.loading.value) {
            this.fetchBranches();
        }

        return h.div(
            { class: "min-vh-100 py-4 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                h.div(
                    {
                        class: "mb-4 d-flex align-items-center justify-content-between",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm rounded-circle p-2",
                                onclick: "history.back()",
                            },
                            h.SolidIcon("arrow-left"),
                        ),
                        h.h2({ class: "fw-bold mb-0" }, "Branches"),
                    ),
                    h.button(
                        {
                            class: "btn btn-primary rounded-pill px-4",
                            onclick: this.method("showForm"),
                        },
                        "Add Branch",
                    ),
                ),

                // Bulk Toggles Cards
                v(this.branches, (b) => {
                    if (!b.value || b.value.length === 0) return null;

                    return h.div(
                        { class: "row g-3 mb-4" },
                        h.div(
                            { class: "col-6" },
                            h.div(
                                {
                                    class: "card border-0 shadow-sm rounded-4 bg-success-subtle text-success h-100 p-2",
                                    role: "button",
                                    onclick: this.method("bulkToggle", [true]),
                                },
                                h.div(
                                    {
                                        class: "card-body text-center d-flex flex-column align-items-center justify-content-center gap-2",
                                    },
                                    h.i({
                                        class: "bi bi-check-circle-fill fs-2",
                                    }),
                                    h.span(
                                        { class: "fw-bold" },
                                        "Go Online (All)",
                                    ),
                                ),
                            ),
                        ),
                        h.div(
                            { class: "col-6" },
                            h.div(
                                {
                                    class: "card border-0 shadow-sm rounded-4 bg-danger-subtle text-danger h-100 p-2",
                                    role: "button",
                                    onclick: this.method("bulkToggle", [false]),
                                },
                                h.div(
                                    {
                                        class: "card-body text-center d-flex flex-column align-items-center justify-content-center gap-2",
                                    },
                                    h.i({ class: "bi bi-x-circle-fill fs-2" }),
                                    h.span(
                                        { class: "fw-bold" },
                                        "Go Offline (All)",
                                    ),
                                ),
                            ),
                        ),
                    );
                }),

                v(this.loading, (l) => {
                    if (l.value)
                        return h.div(
                            { class: "text-center py-5" },
                            h.Spinner(),
                        );

                    return v(this.branches, (b) => {
                        if (!b.value || b.value.length === 0) {
                            return h.div(
                                {
                                    class: "py-5 d-flex justify-content-center align-items-center",
                                },
                                h.div(
                                    {
                                        class: "card border-0 shadow-sm rounded-4 text-center w-100",
                                        style: "max-width: 420px;",
                                    },
                                    h.div(
                                        { class: "card-body p-5" },
                                        h.div(
                                            {
                                                class: "bg-primary-subtle text-primary rounded-circle d-inline-flex justify-content-center align-items-center mb-4",
                                                style: "width: 80px; height: 80px;",
                                            },
                                            h.i({ class: "bi bi-shop fs-1" }),
                                        ),
                                        h.h4(
                                            { class: "fw-bold mb-3" },
                                            "No Branches Found",
                                        ),
                                        h.p(
                                            { class: "text-muted mb-4 px-2" },
                                            "It looks like you haven't added any branches yet. Start by setting up your first location.",
                                        ),
                                        h.button(
                                            {
                                                class: "btn btn-primary rounded-pill px-4 py-2 fw-bold d-inline-flex align-items-center gap-2",
                                                onclick:
                                                    this.method("showForm"),
                                            },
                                            h.i({ class: "bi bi-plus-lg" }),
                                            "Add First Branch",
                                        ),
                                    ),
                                ),
                            );
                        }

                        return h.div(
                            { class: "row g-3" },
                            ...b.value?.map((branch) =>
                                this.renderBranchItem(branch),
                            ),
                        );
                    });
                }),
            ),
        );
    }

    showForm() {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        this.holder = tool.plainModal([
            h.div(
                { class: "modal-content border-0 shadow-lg rounded-4" },
                h.div(
                    { class: "modal-header p-4" },
                    h.h5({ class: "fw-bold text-primary" }, "Add New Branch"),

                    h.button({
                        type: "button",
                        class: "btn-close",
                        data_bs_dismiss: "modal",
                        aria_label: "Close",
                    }),
                ),
                h.div({ class: "modal-body p-4" }, this.renderBranchForm()),

                h.div(
                    { class: "modal-footer" },

                    h.button("Close", {
                        class: "btn btn-outline-secondary",
                        data_bs_dismiss: "modal",
                    }),

                    h.button(
                        {
                            class: "btn btn-primary px-3 fw-bold",
                            hook: `save-branch-btn-${this.id}`,
                            onclick: this.method("saveBranch", ["${this}"]),
                        },
                        "Save Branch",
                    ),
                ),
            ),
            { class: "modal-fullscreen-sm-down" },
        ]);

        this.holder?.show();
    }

    renderBranchForm() {
        return h.div(
            { class: "row g-4" },
            h.div(
                { class: "col-12" },
                h.label(
                    {
                        class: "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Branch Name",
                ),
                h.input({
                    class: "form-control fs-3",
                    placeholder: "e.g. Nairobi Branch",
                    listeners: {
                        input: (e) => (this.formData.name = e.target.value),
                    },
                }),
                h.small(
                    { class: "text-muted" },
                    "A name to identify this branch (e.g. Town Center, Westlands).",
                ),
            ),

            h.div(
                { class: "col-12 col-md-6" },
                h.label(
                    {
                        class: "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Contact Phone",
                ),
                h.input({
                    class: "form-control fs-4",
                    type: "tel",
                    placeholder: "e.g. 0712345678",
                    listeners: {
                        input: (e) =>
                            (this.formData.contact_phone = e.target.value),
                    },
                }),
                h.small(
                    { class: "text-muted" },
                    "We will send SMS notifications to this number for new orders.",
                ),
            ),

            h.div(
                { class: "col-12 col-md-6" },
                h.label(
                    {
                        class: "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Contact Email",
                ),
                h.input({
                    class: "form-control fs-4",
                    type: "email",
                    placeholder: "e.g. branch@example.com",
                    listeners: {
                        input: (e) =>
                            (this.formData.contact_email = e.target.value),
                    },
                }),
                h.small(
                    { class: "text-muted" },
                    "We will send email notifications to this address for new orders.",
                ),
            ),

            h.div(
                { class: "col-12" },
                h.label(
                    {
                        class: "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Map Location",
                ),
                h.div(
                    { class: "d-flex flex-column gap-2" },
                    h.button(
                        {
                            class: "btn btn-outline-primary d-flex align-items-center gap-2 w-100 justify-content-center py-3 rounded-4 border-2",
                            style: "border-style: dashed;",
                            onclick: this.method("openMap"),
                        },
                        h.i({ class: "bi bi-geo-alt-fill fs-4" }),
                        "Pick Location on Map",
                    ),
                    v(this.pickedLocation, (p) =>
                        p.value
                            ? h.div(
                                  { class: "p-3 bg-light rounded-3 border" },
                                  h.div(
                                      { class: "small text-muted mb-1" },
                                      "Selected Location:",
                                  ),
                                  h.div({ class: "fw-bold" }, p.value),
                              )
                            : null,
                    ),
                    h.small(
                        { class: "text-muted" },
                        "This pin will be used for GPS directions on Google Maps.",
                    ),
                ),
            ),

            h.div(
                { class: "col-12" },
                h.label(
                    {
                        class: "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Detailed Address (for Deliverers)",
                ),
                h.textarea({
                    class: "form-control fs-4",
                    rows: 3,
                    placeholder:
                        "e.g. Shop G10, Ground Floor, Diamond Plaza, opposite the main entrance.",
                    listeners: {
                        input: (e) =>
                            (this.formData.readable_address = e.target.value),
                    },
                }),
                h.small(
                    { class: "text-muted" },
                    "Provide specific details like shop number, floor, or nearby landmarks to help deliverers find you easily.",
                ),
            ),
        );
    }

    openMap() {
        broker.send(
            $e.location.is.needed,
            payload({}, { from: "BRANCH_ADDRESS_FORM" }),
        );
    }

    renderBranchItem(branch) {
        return h.div(
            { class: "col-12" },
            h.div(
                { class: "card border-0 shadow-sm rounded-4" },
                h.div(
                    { class: "card-body p-3 d-flex align-items-center gap-3" },
                    h.div(
                        { class: "bg-primary-subtle text-primary circle p-3" },
                        h.i({ class: "bi bi-geo-alt fs-4" }),
                    ),
                    h.div(
                        {
                            class: "flex-fill",
                            role: "button",
                            onclick: this.method("manageBranch", [branch.id]),
                        },
                        h.h6({ class: "fw-bold mb-1" }, branch.name),
                        h.p(
                            { class: "text-muted small mb-2" },
                            branch?.readable_address || "No address set",
                        ),
                    ),
                    h.button(
                        {
                            class: "btn btn-light btn-sm rounded-circle p-2 d-flex align-items-center justify-content-center",
                            style: "width: 35px; height: 35px;",
                            onclick: this.method("manageBranch", [branch.id]),
                        },
                        h.i({ class: "bi bi-gear text-secondary fs-6" }),
                    ),
                ),
                h.div(
                    { class: "mt-1" },
                    h.CheckYesno(
                        {
                            id: `branch-status-${branch.id}`,
                            checked: branch.is_online,
                            label: {
                                value: "Is this branch Open?",
                                class: "small fw-bold",
                            },
                            onchange: this.method("toggleBranchStatus", [
                                "${this}",
                                branch.id,
                            ]),
                        },
                        {
                            class: "check-yesno-end d-flex justify-content-between align-items-center px-3 pb-3",
                        },
                    ),
                ),
            ),
        );
    }

    async fetchBranches() {
        try {
            const res = await api.get(`companies/${this.businessId}/branches`);
            
            if (res) {
                this.branches.value = res.data.branches;
            }
        } catch (e) {
            consoleErrorOnLocal(e);
        } finally {
            this.loading.value = false;
        }
    }

    async saveBranch(btn) {
        dom.disable(btn);
        h.Spinner({ parent: btn, resetParent: true });

        let d = this.formData;
        d.businessId = this.businessId;

        d.organization = { type: "Company", id: this.businessId };

        broker.send($e.branch.needs.creation, payload(d));
    }

    manageBranch(id) {
        router.to("business.branch.manage", {
            companyId: this.businessId,
            branchId: id,
        });
    }

    toggleBranchStatus(elem, branchId) {
        broker.send(
            $e.branch.needs.toggleOnline,
            payload({
                id: branchId,
                businessId: this.businessId,
                is_online: elem.checked,
            }),
        );
    }

    bulkToggle(isOnline) {
        broker.send(
            $e.branch.needs.bulkToggleOnline,
            payload({
                businessId: this.businessId,
                is_online: isOnline,
            }),
        );
    }

    async deleteBranch(id) {
        broker.send(
            $e.branch.needs.deletion,
            payload({ id, businessId: this.businessId }),
        );
    }

    $$branch = {
        created: () => {
            const btn = dom.get(`[hook="save-branch-btn-${this.id}"]`);
            dom.enable(btn);
            dom.put("Save Branch", btn);
            this.holder?.hide();

            setTimeout(() => {
                this.fetchBranches();
            }, 1000);
        },

        updated: () => {
            this.fetchBranches();
        },

        has: {
            creationError: () => {
                const btn = dom.get(`[hook="save-branch-btn-${this.id}"]`);
                dom.enable(btn);
                dom.put("Save Branch", btn);

                this.holder?.hide();
                setTimeout(() => {
                    this.holder?.hide();

                    this.fetchBranches();
                }, 1000);
            },
        },
    };
}

ojs(ManageBranches);
